import { RootState } from '../../../../rootReducer';

export const seriesSelector = (state: RootState) => state.codeBankModuleReducer.SeriesReducer;
